<template>
  <div class="container">
    <vue-headful title="ABL Groupe | Realisations" />
    <h2>CNFPT Lille</h2>
    <section class="society--process">
      <div class="society--content">
        <div class="society--process--picture col-xs-12 col-md-5">
          <img :src="require('../../assets/images/cnfpt-lille.jpg')"/>
        </div>
        <div class="society--process--description flex-end col-xs-12 col-md-5">
          <div class="col-xs-12 schema--container">
            <img class="img--schema" :src="require('../../assets/images/cnfpt.png')" alt="">
            <h3>Profilé extrudé montant de façade vitrée</h3>
            <div>
              <p>Dimensions : 137 x 60 mm</p>
              <p>Matière : S 355 J2H</p>
              <p>Architecte : Brenac + Gonzales</p>
              <p>Photo : Sergio GRAZIA</p>
            </div>
            <img class="img--schema-bot" :src="require('../../assets/images/lille.png')" alt="">
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ExtrudedProfileGlazedFaceUpright"
}
</script>

<style lang="scss" scoped>
.society--process--picture {
  img {
    height: 100%!important;
    width: 100%;
    box-shadow: none;
  }
}
.schema--container {
  display: flex;
  flex-direction: column;
  .img--schema-bot {
  }
}
.society--process {
  display: flex;
  flex-direction: row;
  & .img--schema {
    width: auto;
    height: 300px;
    object-fit: none;
    margin-top: auto;
  }
}


</style>